import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class MessageService {
  constructor(private readonly _httpClient: HttpClient) {}

  async getMessages() {
    return this._httpClient.get(
      environment.api('api/notification/user'),
    );
  }

  async getMessageDetail(messageId: string) {
    let params = {
      messageId: messageId
    };

    return this._httpClient.get(
      environment.api('api/notification/detail'),
      { params : params }
    );
  }

  async updateMessage(
    notificationId: string,
    userId: string,
    deleted: boolean
  ) {

    let params = {
      notification: {
        Id: notificationId,
        To: userId,
        Deleted: deleted,
      }
    };

    return this._httpClient.post(
      environment.api('api/notification/update'),
      params
    );
  }

  async markAllMessagesAsRead() {
    return this._httpClient.get(
      environment.api('api/notification/read_all'),
    );
  }

  async showBadge() {
    return this._httpClient.get(
      environment.api('api/notification/show_badge'),
    );
  }

  RegisterDevice(
    userId: string,
    token: string,
    platform: string,
    deviceEndpointArn: string
  ) {
    let params = {
      userId,
      token,
      platform,
      deviceEndpointArn,
    };
    console.log("🚀 ~ MessageService ~ params:", JSON.stringify(params));

    return this._httpClient.post(environment.api('api/notification/register_device'), params);
  }
}
